// assets/impact-banner-ticker.js
// Fetches impact value from API and animates all ticker instances in the global banner

(() => {
  const postJSON = async (url, body) => {
      const r = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body || {})
      });
      if (!r.ok) throw new Error(`${url} ${r.status}`);
      return r.json();
  };
  async function computeImpactTicker() {
    try {
      let netlify_domain = window.netlify_function_domain;  

      // const data = await postJSON('/apps/cause/get-benefit-data');

      function formatNumberWithCommas(x) {
        if (typeof x === 'number') x = x.toString();
        return x.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }

      function animateCounter(from, to, duration, updateFn) {
        let startTimestamp = null;
        function step(timestamp) {
          if (!startTimestamp) startTimestamp = timestamp;
          const progress = timestamp - startTimestamp;
          const rawIncrement = Math.ceil(((to - from) / duration) * progress);
          const adjustedIncrement = Math.max(rawIncrement, 10000);
          let nextValue = from + adjustedIncrement;
          if (nextValue < to) {
            updateFn(nextValue);
            window.requestAnimationFrame(step);
          } else {
            updateFn(to);
          }
        }
        window.requestAnimationFrame(step);
      }

      function updateAllImpactCursorsAnimated(data) {
        var cursorSpans = document.querySelectorAll('.ql-cursor');
        if (cursorSpans.length && data && typeof data.days_of_school !== 'undefined') {
          var finalValue = parseInt(data.days_of_school, 10) * 3;
          var fromValue = Math.max(finalValue - 20000, 0);
          var duration = 2000; // 2 seconds
          cursorSpans.forEach(function(cursorSpan) {
            // Create a span to hold the animated value
            var animatedSpan = document.createElement('span');
            animatedSpan.className = 'impact-banner-heading';
            // Replace the ql-cursor span with the animated span
            cursorSpan.parentNode.replaceChild(animatedSpan, cursorSpan);
            animateCounter(fromValue, finalValue, duration, function(val) {
              animatedSpan.textContent = formatNumberWithCommas(val);
            });
          });
          return true;
        } else {
          console.warn('ql-cursor span not found or days_of_school missing');
          return false;
        }
      }

      // Cache key and expiry (24 hours in ms)
      const CACHE_KEY = 'impact_benefit_data';
      const CACHE_EXPIRY = 24 * 60 * 60 * 1000;

      // Try to get cached data
      let cached = localStorage.getItem(CACHE_KEY);
      let data = null;
      if (cached) {
        try {
          cached = JSON.parse(cached);
          if (cached.timestamp && (Date.now() - cached.timestamp < CACHE_EXPIRY)) {
            data = cached.data;
          }
        } catch (e) {
          // Ignore parse errors and fetch fresh data
        }
      }
      if (!data) {
        data = await postJSON(`${netlify_domain}/.netlify/functions/get-benefit-data-from-blob`);
        localStorage.setItem(CACHE_KEY, JSON.stringify({ data, timestamp: Date.now() }));
      }
      // Share the same figure with the rest of the page (the my-impact
      // hero's "raised together"): window.OlivelaImpactBenefit plus an
      // event for anything already waiting.
      window.OlivelaImpactBenefit = data;
      document.dispatchEvent(new CustomEvent('olivela:impact-benefit', { detail: data }));
      // Try immediately
      updateAllImpactCursorsAnimated(data);
      const global_header = document.getElementsByClassName('shopify-section-group-header-group')[0];

      // Use MutationObserver to watch for .ql-cursor elements
      if(global_header){
        const observer = new MutationObserver(() => {
          if (updateAllImpactCursorsAnimated(data)) {
            observer.disconnect();
          }
        });
        observer.observe(global_header, { childList: true, subtree: true });
      }

      // As a fallback, also try after a short delay
      setTimeout(() => updateAllImpactCursorsAnimated(data), 2000);
    } catch (e) {
      console.warn('Failed to fetch benefit data:', e);
    }
  }
  function bindImpactTicker() {
    const trigger = async () => {
        await computeImpactTicker();
      };
      // Initial render
      trigger();
  }
  bindImpactTicker();

  
})();
